var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AnimalForm',{directives:[{name:"show",rawName:"v-show",value:(_vm.animal!=='undefined'),expression:"animal!=='undefined'"}],attrs:{"adminmethod":"update","animal":_vm.animal}})}
var staticRenderFns = []

export { render, staticRenderFns }